import React, { Component } from 'react';

import { Document, Page } from 'react-pdf'

import 'styles/resume.scss';


class ResumePage extends Component {

  state = {
    numPages: null,
  }
 
  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }
 
  render() {
    // TODO 
    return (
      <div className='resume-container'>
        <Document
          file={require('static/misc/resume.pdf')}
          onLoadSuccess={this.onDocumentLoadSuccess}
        >
          <Page pageNumber={1} width={900}/> 
        </Document>
      </div>
    );
  }
}

export default ResumePage;



// WEBPACK FOOTER //
// ./src/components/ResumePage/ResumePage.js